export const GROW_NETWORK_COPY = {
  referrer: {
    headline: "The bigger your network, the more you earn",
    supporting:
      "Import your contacts and grow your referral pool. More connections = more Tier 3 jobs you can fill.",
  },
  job_seeker: {
    headline: "Get discovered faster",
    supporting:
      "When more people in your industry are on Workbrook, you are more likely to be referred for the right role.",
  },
  employer: {
    headline: "Your jobs travel further",
    supporting:
      "A bigger referral pool means your Tier 3 postings reach more qualified candidates, faster.",
  },
};

/**
 * Derive Grow Your Network persona from user data + stats.
 * Note: account_type "referral" users often have user_type "1" (can post);
 * do not treat user_type alone as employer.
 */
export function getGrowNetworkPersona(userData, stats = {}) {
  if (userData?.account_type === "business") {
    return "employer";
  }
  if (stats?.has_referred || (stats?.invites_sent || 0) > 0) {
    return "referrer";
  }
  return "job_seeker";
}

export const NDPA_CONSENT_TEXT =
  "By importing contacts, you confirm you have permission to share their information with Workbrook for the purpose of inviting them to the platform. Imported contact data (name and email) is stored only for matching and invite purposes, is not shared with other users or third parties, and may be deleted from your account settings at any time. This complies with the Nigeria Data Protection Act (NDPA) 2023.";

export const NDPA_CONSENT_POINTS = [
  {
    title: "What we store",
    text: "Name, email, and/or phone from the contacts you import.",
  },
  {
    title: "How we use it",
    text: "To match people already on Workbrook and to send invites you choose. Nothing is sent until you confirm.",
  },
  {
    title: "What we don’t do",
    text: "We do not share your contacts with other users or third parties.",
  },
  {
    title: "Your control",
    text: "You can opt out and delete all imported contacts anytime from the Contacts tab or Settings.",
  },
];

export const IMPORT_HOW_IT_WORKS =
  "Choose Google Contacts or upload a CSV. We’ll match people already on Workbrook, then you preview the list and pick who to invite. Nothing is sent until you click Send Invites. You can opt out and delete all imported contacts at any time.";

export function defaultInviteEmailSubject(inviterName) {
  return `${inviterName || "A Workbrook user"} invited you to Workbrook`;
}

export function defaultInviteEmailBody(inviterName) {
  return `${inviterName || "A friend"} invited you to join Workbrook — the referral marketplace where professionals connect talent to opportunity.`;
}

export function defaultInviteSmsBody(inviterName) {
  return `${inviterName || "A Workbrook user"} invited you to Workbrook. Join here: [invite_link]`;
}
